
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","viewBox":"0 0 34 34","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 33C25.8223 33 33 25.8229 33 17C33 8.17706 25.8223 1 17 1C8.17775 1 1 8.17706 1 17C1 25.8229 8.17775 33 17 33ZM17 2.33331C25.0872 2.33331 31.6667 8.91275 31.6667 17C31.6667 25.0872 25.0872 31.6667 17 31.6667C8.91275 31.6667 2.33331 25.0872 2.33331 17C2.33331 8.91275 8.91275 2.33331 17 2.33331Z","fill":"currentColor","stroke":"currentColor"}}),_c('path',{attrs:{"d":"M16.5286 22.1379C16.789 22.3984 17.2109 22.3984 17.4713 22.1379L24.8047 14.8046C25.0651 14.5442 25.0651 14.1223 24.8047 13.8619C24.5442 13.6015 24.1224 13.6015 23.862 13.8619L17 20.7239L10.138 13.8619C10.0078 13.7317 9.83717 13.6665 9.66661 13.6665C9.49605 13.6665 9.32548 13.7317 9.19523 13.8619C8.9348 14.1223 8.9348 14.5442 9.19523 14.8045L16.5286 22.1379Z","fill":"currentColor","stroke":"currentColor"}})])
          )
        }
      }
    